import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContactComponent } from './components/contact/contact.component';
import { FrontpageComponent } from './components/frontpage/frontpage.component';
import { PublicationsComponent } from './components/publications/publications.component';
import { TeachingComponent } from './components/teaching/teaching.component';


const routes: Routes = [
    { path: '', component: FrontpageComponent, pathMatch: 'full'},
    { path: 'teaching', component: TeachingComponent, pathMatch: 'full'},
    { path: 'publications', component: PublicationsComponent, pathMatch: 'full'},
    { path: 'contact', component: ContactComponent, pathMatch: 'full'}
    // { path: ':id', component: SinglePageComponent, data: { state: 'id'}, pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
